import React, { useState } from "react";
import { Button, Popover, List, ListItem, ListItemIcon,
        ListItemText, makeStyles, useTheme } from '@material-ui/core';
import carIcon from "../../../images/mapPins/carPin.svg";
import motorbikeIcon from "../../../images/mapPins/motorMapIcon2.png";
import mapPin from 'leaflet/dist/images/marker-icon.png';
import routeSymbol from "../../../images/routeLegend.png";
import routeSpeedExceededAbove10Legend from "../../../images/routeSpeedExceededAbove10Legend.png";
import routeSpeedExceededAbove30Legend from "../../../images/routeSpeedExceededAbove30Legend.png";
import routeSpeedExceededAbove50Legend from "../../../images/routeSpeedExceededAbove50Legend.png";
import zoneSymbol from "../../../images/regionLegend.png";
import incidentSymbol from "../../../images/mapPins/dangerPin.png";
import refuelSymbol from "../../../images/mapPins/fuelPin.png";
import startRouteSymbol from "../../../images/mapPins/startRoutePin.png";
import finishRouteSymbol from "../../../images/mapPins/finishRoutePin.png";
import t from "../../../languages/pl";

const useStyles = makeStyles(theme => ({
    image: {
        height: 25,
        width: 36,
    },
    container: {
        display: "flex"
    },
    text: {
        marginLeft: theme.spacing(1)
    },
    icon: {
        minWidth: 20,
        minHeight: 20,
        margin: theme.spacing(1)
    },
    buttonColor: {
        background: "#FFF",
        color: "#000",
        "&:hover" : {
            background: "#F4F4F4",
        }
    }
}));

export default function Legend() {
    const theme = useTheme();
    const classes = useStyles(theme);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleButtonClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Button
                variant="contained"
                size="small"
                color="secondary"
                classes={{containedSecondary: classes.buttonColor}}
                onClick={handleButtonClick}
            >
                {t.legend}
            </Button>
            <Popover
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
            >
                <div className={classes.container}>
                <List>
                    <ListItem>
                        <ListItemIcon className={classes.icon} style={{marginLeft: 0}}>
                            <img src={carIcon} alt="Car icon"  className={classes.image} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                            {t.car}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon} style={{marginLeft: 0}}>
                            <img src={motorbikeIcon} alt="Car icon"  className={classes.image} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                            {t.motorbike}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={startRouteSymbol} alt="start" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                            {t.routeBegin}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={finishRouteSymbol} alt="finish" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                            {t.routeFinish}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={refuelSymbol} alt="incodent" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                            {t.refuel}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={incidentSymbol} alt="incodent" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                            {t.incident}
                        </ListItemText>
                    </ListItem>
                </List>
                <List>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={routeSymbol} alt="route" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                           {t.routeWithoutOverruns}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={routeSpeedExceededAbove10Legend} alt="exceeded above 10" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                           {t.speedExceededAbove10}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={routeSpeedExceededAbove30Legend} alt="exceeded above 30" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                           {t.speedExceededAbove30}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={routeSpeedExceededAbove50Legend} alt="exceeded above 30" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                           {t.speedExceededAbove50}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={zoneSymbol} alt="zone" style={{height: 25}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text}>
                            {t.zoning}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            <img src={mapPin} alt="Map pin" style={{height: 25, marginLeft: 5}} />
                        </ListItemIcon>
                        <ListItemText className={classes.text} style={{paddingLeft: 5}}>
                            {t.customPin}
                        </ListItemText>
                    </ListItem>
                </List>
                </div>
            </Popover>
        </React.Fragment>
    );
}